/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import { isExpired, decodeToken } from 'react-jwt';
import { injectable } from 'inversify';

@injectable()
export class JwtModule {
  static displayName = 'JwtModule';

  decode(jwt: string) {
    return decodeToken(jwt);
  }

  isExpired(jwt: string) {
    return isExpired(jwt);
  }

  verify(jwt: string) {
    const decoded = decodeToken(jwt);
    const expiry = isExpired(jwt);
    return {
      status: !expiry,
      decoded: decoded,
    };
  }
}
